import React  from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY, AUTHENTICATED_ENTRY_ADMIN } from 'configs/AppConfig'

const PublicRoute = () => {

	const { token, user } = useSelector(state => state.auth)

	console.log(user);
	console.log(user?.role?.includes('company'));
  
	return token ? <Navigate to={user?.role?.includes('company') ? AUTHENTICATED_ENTRY : AUTHENTICATED_ENTRY_ADMIN} /> : <Outlet/>
}

export default PublicRoute